import JSZip from 'jszip';
import { ITrimEditorManagerBase } from '../trim-editor.manager';
import { TrimUiManager } from '../ui/trim.ui.manager';

export class TrimZipManager implements ITrimEditorManagerBase {
  private uiManager!: TrimUiManager;
  private static zips: { id: string, zip: JSZip }[] = [];

  private getXmlFile: (v: { file: any, path: string, callback: (p: { file: any }) => void }) => void = async (v: {
    file: any,
    path: string,
    callback: (p: { file: any }) => void
  }, id?: string) => {
    const file = await this.unzipAndGetFile(v.file, v.path, 'blob', id);
    v.callback({ file: file });
  };

  initialize(): void {
    this.uiManager.on('t->r:zip-file:get', this.getXmlFile);
  }

  destroy(): void {
    this.uiManager.off('t->r:zip-file:get', this.getXmlFile);
  }

  di(
    uiManager: TrimUiManager,
  ): void {
    this.uiManager = uiManager;
  }

  unzip(file: Blob, id?: string) {
    const zip = new JSZip();
    return zip.loadAsync(file);
  }

  unzipAndGetFile(zipFile: Blob, targetFilePath: string, type: 'text' | 'blob', id?: string) {
    const find = TrimZipManager.zips.find((v) => v.id === id);
    if (find) return find.zip.file(targetFilePath)?.async(type);
    return this.unzip(zipFile)
      .then((v) => {
        if (id) TrimZipManager.zips.push({ id, zip: v });
        return v.file(targetFilePath)?.async(type);
      });
  }
}
